interface RentList {
    area: string,
    money: string
}

let list = [
    {
        area: "杭州",
        money: "1500"
    },
    {
        area: "上海",
        money: "1500"
    },
    {
        area: "北京",
        money: "1500"
    },
    {
        area: "天津",
        money: "1500"
    },
    {
        area: "合肥",
        money: "1500"
    },
    {
        area: "武汉",
        money: "1500"
    },
    {
        area: "广州",
        money: "1500"
    },
    {
        area: "无锡",
        money: "1100"
    },
    {
        area: "苏州",
        money: "1100"
    },
    {
        area: "南京",
        money: "1500"
    },
    {
        area: "宁波",
        money: "1500"
    },
    {
        area: "长沙",
        money: "1500"
    },
    {
        area: "福州",
        money: "1100"
    }
]

let RentList = {
    list: list,
}
export default RentList